import { useCallback } from 'react';

import type { EventName } from '@/utils/mixpanel';
import { useTrackEventWithOptionalParams } from '@/utils/mixpanel';

export const useVideaNotesAnalytics = (
  eventTrackingUserPayload: Record<string, unknown>,
) => {
  const { trackEvent } = useTrackEventWithOptionalParams();

  const trackVideaNotesEvent = useCallback(
    (event: EventName, additionalPayload?: Record<string, unknown>) => {
      trackEvent(event, { ...eventTrackingUserPayload, ...additionalPayload });
    },
    [trackEvent, eventTrackingUserPayload],
  );

  return { trackVideaNotesEvent };
};
